import script from "./late-attendance.vue?vue&type=script&lang=js&setup=true"
export * from "./late-attendance.vue?vue&type=script&lang=js&setup=true"

import "./late-attendance.vue?vue&type=style&index=0&id=ca93b666&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca93b666"]])

export default __exports__